import { render, staticRenderFns } from "./update-ticket.vue?vue&type=template&id=24f17856"
import script from "./update-ticket.vue?vue&type=script&lang=js"
export * from "./update-ticket.vue?vue&type=script&lang=js"
import style0 from "./update-ticket.vue?vue&type=style&index=0&id=24f17856&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports